import React, { Component, PropTypes } from 'react';
import { TextField as MatTextField } from 'material-ui';
import * as Colors from 'components/Material/Styles/Colors';

const styles = {
  input: {
    color: Colors.Colors.fullWhite
  }
};

export default class TextField extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  componentDidMount() {
    const { field } = this.refs;
    const inputField = field._getInputNode();
    const value = field.getValue();
    field.focus();
    field.setValue(value);
    inputField.select();
  }

  getValue() {
    return this.refs.field.getValue();
  }

  render() {
    return (
      <MatTextField inputStyle={styles.input} ref="field" {...this.props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Course/TableOfContents/TextField.js